@import "@workbench/core/dist/scss/globals";
@import "@workbench/core/dist/scss/utility";

:host {
  --cmm-color-overlay-opacity: rgb(0 0 0 / 40%);
  --cmm-color-modal-opacity: rgb(0 0 0 / 80%);

  .cmm-cookie-banner__wrapper {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    color: var(--wb-grey-15, #262626);
    z-index: 2000;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.25s, visibility 0.25s;

    &.visible {
      opacity: 1;
      visibility: visible;
    }

    .cmm-cookie-banner__overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: var(--cmm-color-overlay-opacity, rgb(0 0 0 / 40%));
      color: var(--wb-grey-15, #262626);
      transition: opacity 0.25s, visibility 0.25s;
      z-index: 2001;
    }

    .cmm-cookie-banner__content {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      margin: 0 auto;
      width: 95%;
      max-width: 1200px;
      max-height: 70vh;
      background-color: var(--wb-white, #fff);
      padding: var(--wb-spacing-xs, 1rem) var(--wb-spacing-xs, 1rem) 0 var(--wb-spacing-xs, 1rem);
      border-top-right-radius: 4px;
      border-top-left-radius: 4px;
      box-shadow: 0 0 4px 0 rgb(0 0 0 / 10%), 0 16px 24px 0 rgb(0 0 0 / 10%);
      overflow-x: hidden;
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      z-index: 2002;
      outline: none;

      .main-title {
        margin: 0 0 var(--wb-spacing-xs, 1rem);
      }

      @media screen and (min-width: 768px) {
        .main-title {
          font-family: var(--wb-font-title, "MBCorpo Title", "DaimlerCAC-Regular", "DaimlerCACArab-Regular", serif);
          font-style: normal;
          font-weight: 400;
          font-size: 2.125rem;
          line-height: 2.75rem;
        }
      }

      .main-description {
        margin-bottom: var(--wb-spacing-xs, 1rem);
      }

      .hint-text {
        margin: var(--wb-spacing-xs, 1rem) 0;
      }

      .toggle-button {
        > cmm-icon {
          transform: rotate(180deg);
          transition: 250ms;
        }
      }

      &.settings-expanded {
        #cookie-settings {
          display: block;
        }

        .toggle-button {
          > cmm-icon {
            transform: rotate(0);
          }
        }
      }

      .category-item {
        .consent-list {
          display: none;
        }

        .toggle-button {
          cmm-icon {
            transform: rotate(180deg);
            transition: 250ms;
          }
        }
      }

      .category-item--expanded {
        .consent-list {
          display: grid;
        }

        .toggle-button {
          cmm-icon {
            transform: rotate(0deg);
            transition: 250ms;
          }
        }
      }
    }
  }

  .toggle-button {
    padding: 0;
    border: none;
    outline: none;
    background: none;
    display: block;
    font-size: 1rem;
    cursor: pointer;
    margin: 0 auto var(--wb-spacing-xs, 1rem);
    color: var(--wb-blue-45, #0078d6);

    cmm-icon {
      display: block;
      width: 32px;
      height: auto;
      margin: 0 auto;
    }
  }

  .button-group {
    display: flex;
    flex-direction: column;

    @media screen and (min-width: 768px) {
      flex-direction: row;
      justify-content: flex-end;
    }

    .button {
      width: 100%;
      margin-bottom: var(--wb-spacing-xs, 1rem);
      text-align: center;

      &--accept-all {
        order: 1;
      }

      &--toggle-cookie-details {
        order: 2;
      }

      &--only-technically-necessary,
      &--confirm-selection {
        order: 3;
      }

      &__icon {
        margin-right: 0.5rem;
      }

      @media screen and (min-width: 768px) {
        width: auto;
        margin: 0 0 1rem 1rem;

        &--accept-all {
          order: 3;
        }

        &--toggle-cookie-details {
          order: 2;
        }

        &--only-technically-necessary,
        &--confirm-selection {
          order: 1;
        }
      }
    }
  }

  .cmm-cookie-banner__settings-page {
    background-color: var(--wb-white, #fff);
    color: var(--wb-grey-15, #262626);
    padding: var(--wb-spacing-m, 2rem) var(--wb-spacing-xs, 1rem);

    .main-title {
      margin: 0 0 var(--wb-spacing-xs, 1rem) 0;
    }

    .main-description {
      margin-bottom: var(--wb-spacing-xs, 1rem);
    }

    .hint-text {
      margin: var(--wb-spacing-xs, 1rem) 0;
    }

    @media screen and (min-width: 768px) {
      .main-title {
        font-family: var(--wb-font-title, "MBCorpo Title", "DaimlerCAC-Regular", "DaimlerCACArab-Regular", serif);
        font-style: normal;
        font-weight: 400;
        font-size: 2.125rem;
        line-height: 2.75rem;
      }
    }

    #cookie-settings {
      display: block;
    }
  }

  #cookie-settings {
    display: none;
  }

  .select-all-item {
    @include wb-text("m");

    display: flex;
    margin-bottom: var(--wb-spacing-s, 2rem);
  }

  .category {
    &-overview {
      margin: var(--wb-spacing-xs, 1rem) 0;

      @media screen and (min-width: 768px) {
        display: flex;
        justify-content: space-between;
      }

      &-item {
        font-size: 17px;
        margin: 0;

        @media screen and (max-width: 768px) {
          margin: var(--wb-spacing-xxs, 0.5rem) 0;
        }

        @media screen and (min-width: 1080px) {
          flex: 1;
        }

        .cmm-checkbox-fake {
          font-size: 27px;
        }
      }
    }

    &-item {
      &:not(:last-of-type)::after {
        content: "";
        display: block;
        width: 50px;
        height: 1px;
        background: var(--wb-black, #000);
        margin: var(--wb-spacing-s, 2rem) 0 var(--wb-spacing-s, 2rem);
      }
    }

    &-select-all {
      font-weight: bold;
      display: flex;
    }

    &-description {
      margin: var(--wb-spacing-xs, 1rem) 0;
    }
  }

  .consent {
    &-list {
      padding-left: var(--wb-spacing-m, 2rem);
      margin-bottom: var(--wb-spacing-xs, 1rem);
      display: grid;
      grid-template-columns: 1fr;
      width: 100%;

      @media screen and (min-width: 768px) {
        grid-template-columns: 1fr 1fr;
      }

      @media screen and (min-width: 1080px) {
        grid-template-columns: 1fr 1fr 1fr;
      }
    }

    &-item {
      display: flex;
      break-inside: avoid;
      margin-bottom: var(--wb-spacing-xs, 1rem);

      @media screen and (min-width: 1080px) {
        padding-right: var(--wb-spacing-m, 2rem);
        line-height: 1.4;
      }

      &__information {
        flex-grow: 2;
      }

      &__name {
        @include wb-text("m");

        display: inline;
        margin-right: 0.5em;
      }

      &__icon {
        padding: 0;
        border: none;
        outline: none;
        background: none;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        font-size: 1rem;
        width: 1.4em;
        height: 1.4em;
        color: var(--wb-grey-60, #9f9f9f);
        cursor: pointer;
        vertical-align: bottom;

        &:focus {
          outline-offset: 0.3125rem;
          outline-style: solid;
          outline-width: 0.0625rem;
        }
      }
    }
  }

  [dir="rtl"].cmm-cookie-banner {
    .cmm-checkbox-fake {
      margin-left: 10px;
      margin-right: 0;
    }

    .consent-item__name {
      margin-right: 0;
      margin-left: 0.5em;
    }
  }
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.cmm-checkbox {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  user-select: none;
  margin-right: 0.75em;

  --checkbox-size: 23px;

  input {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    clip-path: inset(50%);
    border: 0;

    &:not([disabled], .cmm-checkbox-input--category):checked + .cmm-checkbox-fake,
    &:not([disabled]).selected-all + .cmm-checkbox-fake {
      background: var(--wb-blue-45, #0078d6);
      border-color: var(--wb-blue-45, #0078d6);
    }

    &.cmm-checkbox-input--category.selected-partial + .cmm-checkbox-fake {
      background: var(--wb-blue-45, #0078d6);
      border-color: var(--wb-blue-45, #0078d6);

      &::after {
        content: "";
        width: 0.6em;
        height: 2px;
        background: var(--wb-white, #fff);
      }
    }

    &:not(.cmm-checkbox-input--category):checked + .cmm-checkbox-fake::after,
    &.selected-all + .cmm-checkbox-fake::after {
      content: "";
      width: 0.67em;
      height: 0.25em;
      border-bottom: 2px solid var(--wb-white, #fff);
      border-left: 2px solid var(--wb-white, #fff);
      transform: rotate(-45deg) translate(0.04em, -0.025em);
    }

    &[disabled] + .cmm-checkbox-fake {
      background: var(--wb-grey-70, #bbb);
      cursor: not-allowed;
    }

    &:focus + .cmm-checkbox-fake {
      outline: 1px solid var(--wb-blue-45, #0078d6);
    }
  }

  &-fake {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: var(--checkbox-size);
    width: 1em;
    height: 1em;
    border: 1px solid var(--wb-grey-70, #bbb);
    background: var(--wb-grey-95, #f8f8f8);
    margin-right: 10px;
    cursor: pointer;
  }
}
